export default [
  { order: 2, id: 1, code: "en", display: "Inglés" },
  { order: 1, id: 2, code: "es", display: "Español" },
  { order: 5, id: 3, code: "fr", display: "Francés" },
  { order: 7, id: 4, code: "zh", display: "Chino" },
  { order: 4, id: 5, code: "it", display: "Italiano" },
  { order: 3, id: 6, code: "pt", display: "Portugués" },
  { order: 6, id: 7, code: "de", display: "Alemán" },
];
